import { render, staticRenderFns } from "./AnnouncmentTable.vue?vue&type=template&id=f2fe7194&"
import script from "./AnnouncmentTable.vue?vue&type=script&lang=js&"
export * from "./AnnouncmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports